<template>
  <div id="snail">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "Snail"
};
</script>

<style lang="less">
#snail {
  overflow: hidden;
  position: relative;
  width: 100%;
  height: 100vh;
  height: 100svh;
  // height: 100svh !important;
  margin: 0 auto;
}
.my-snail-tip .mint-toast-text {
  font-size: 24px !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/snail/App.vue